const prefix = '/api';

module.exports = {
    httpApiPrefixPath: prefix,
};
